import './main.scss';
import '../../facsimileViewer/dist/facsimile-viewer.css';
import { FacsimileViewer, FullPageViewer, LineViewer, TopViewer } from "../../facsimileViewer/dist";

const facsimileElement = document.getElementById('facsimile');
const facsimileViewer = new FacsimileViewer(facsimileElement, 'div.paragraph', {});

const viewers = [new LineViewer({}), new TopViewer({})];
const switchViewer = () => {
  viewers.push(viewers.shift());
  return viewers[0];
}
facsimileViewer.setViewer(viewers[0]);

document.querySelectorAll('a.anchor')
  .forEach(a => a.setAttribute('href', '#' + a.getAttribute('name')))

document.querySelector('body').addEventListener('click', event => {
  const el = <HTMLElement> event.target;
  if (el.classList.contains('pbImg')) {
    const ref = el.getAttribute('data-ref').substring(1);
    const url = new URL(location.href);
    url.hash = '';
    location.assign(url.toString().replace(/\/+$/, '') + '/text-image#' + ref);
  } else if (el.classList.contains('lb')) {
    facsimileViewer.setViewer(switchViewer());
  }
});
